import { Immutable } from "immer";
import React from "react";

import { templates } from "@reactivated";

import { StreamField } from "@thelabnyc/thelabui/src/components/StreamField";

import { footerComponentsMap } from "../blocks/componentMaps";
import { FinancingPageBody } from "../components/FinancingPageBody";
import { PageSkeleton } from "../components/PageSkeleton";

const FinancingPageFinePrint = (
    props: Immutable<{ page: templates.FinancingPageTemplate["page"] }>,
): React.JSX.Element | null => {
    if (!props.page.fine_print) {
        return null;
    }
    return (
        <>
            {props.page.fine_print.value.map((block) => (
                <StreamField
                    key={block.id}
                    tagName="div"
                    attrs={{
                        className: `w-block-${block.type} block-${block.type}`,
                    }}
                    value={[block]}
                    components={footerComponentsMap}
                />
            ))}
        </>
    );
};

export const Template = (
    props: Immutable<templates.FinancingPageTemplate>,
): React.JSX.Element => {
    return (
        <PageSkeleton
            pageChrome={props.page_chrome}
            afterFooter={<FinancingPageFinePrint page={props.page} />}
        >
            <FinancingPageBody
                page={props.page}
                prequal_settings={props.prequal_settings}
            />
        </PageSkeleton>
    );
};
